import React, { useEffect, useState } from 'react';
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import BarChartItem from '../BarChartItem/BarChartItem';
import { toast } from "react-toastify";
import Loader from '../../../Loader';
import './InsuranceOverallReport.scss';

const InsuranceOverallReport = () => {
  const [initialData, setInitialData] = useState({});
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    _axios.get(prefixUrl() + "/insurance/?request=insuranceOverallReport").then((response) => {
      if (response.data.status) {
        setInitialData(response.data.data);
        setIsLoad(true)
      } else {
        toast.error(response.data.message);
      }
    })
  }, []);

  const colors = [
    "#FDB97C",
    "#F89170",
    "#F89370",
    "#F36162",
    "#EF495A",
    "#73B791",
    "#6BA395",
    "#618D98",
    "#58769C",
    "#4E5FA0",
    "#CF41A7",
    "#BD3BB8",
  ];

  try {
    return isLoad ?
      (
        <section className="insurance-overall-report">
          <div className="infos-container">
            <div className="info-box">
              <h2 className="info-box-title">تعداد بیمه نامه ها</h2>
              <div className="info-box-value">{initialData?.insuranceTotalCount}</div>
            </div>
            <div className="info-box">
              <h2 className="info-box-title">تعداد مشتریان</h2>
              <div className="info-box-value">{initialData?.customerTotalCount}</div>
            </div>
            <div className="info-box">
              <h2 className="info-box-title">مبلغ کل بیمه نامه</h2>
              <div className="info-box-value">
                {initialData?.insuranceTotalPrice.toLocaleString()}
                <span>تومان</span>
              </div>
            </div>
            <div className="info-box">
              <h2 className="info-box-title">میزان سود قطعی</h2>
              <div className="info-box-value">
                {initialData?.definiteProfit.toLocaleString()}
                <span>تومان</span>
              </div>
            </div>
            <div className="info-box">
              <h2 className="info-box-title">مانده حساب اشخاص</h2>
              <div className="info-box-value">
                {initialData?.customerRemaining.toLocaleString()}
                <span>تومان</span>
              </div>
            </div>
            <div className="info-box">
              <h2 className="info-box-title">مانده حساب شرکت بیمه</h2>
              <div className="info-box-value">
                {initialData?.insuranceCompanyRemaining.toLocaleString()}
                <span>تومان</span>
              </div>
            </div>
            <div className="info-box">
              <h2 className="info-box-title">مانده حساب بازاریاب</h2>
              <div className="info-box-value">
                {initialData?.marketerRemaining.toLocaleString()}
                <span>تومان</span>
              </div>
            </div>
            <div className="info-box">
              <h2 className="info-box-title">میزان سود پیش بینی</h2>
              <div className="info-box-value">
                {initialData?.forecastProfit.toLocaleString()}
                <span>تومان</span>
              </div>
            </div>
          </div>
          <div className="insurance-charts">
            <BarChartItem
              title={"تعداد بیمه نامه ها براساس سال و ماه"}
              data={initialData?.insuranceCountByYearAndMonth}
              colors={colors}
              height={"210px"}
            />
            <BarChartItem
              title={"مبلغ بیمه نامه ها براساس سال و ماه"}
              data={initialData?.insurancePriceByYearAndMonth}
              colors={colors}
              height={"210px"}
            />
            <BarChartItem
              title={"تعداد بیمه نامه ها براساس نوع بیمه نامه"}
              data={initialData?.insuranceCountByInsuranceType}
              colors={colors}
              height={"210px"}
            />
            <BarChartItem
              title={"مبلغ بیمه نامه ها براساس نوع بیمه نامه"}
              data={initialData?.insurancePriceByInsuranceType}
              colors={colors}
              height={"210px"}
            />
          </div>
        </section>
      ) : (
        <Loader />
      );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default InsuranceOverallReport;